import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * dispatch this action for global error handler
 * @param error: Error | HttpErrorResponse
 * @param whitelist?: string[] | number[] an array of http response codes and/or error message containments for which this error should not be globally handled
 */
export const globalFailure = createAction('[Global] Failure', props<{ error: Error | HttpErrorResponse; whitelist?: (string | number)[] }>());

/**
 * dispatch this action if you need to return an action that does nothing
 * @param error: Error | HttpErrorResponse
 * @param whitelist?: string[] | number[] an array of http response codes and/or error message containments for which this error should not be globally handled
 */
export const noopAction = createAction('[Global] NOOP');


export const translationMissingAction = createAction('[Global] translation missing', props<{ language: string; key: string; }>())
